import { WORK_ORDER } from "components/Common/constants";
import CommonTable from "components/ReactTable/Table";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";

function WarrantyApproval() {
  const navigate = useNavigate();
  const [creationDateRange, setCreationDateRange] = useState([null, null]);
  const [scheduleDateRange, setScheduleDateRange] = useState([null, null]);

  const handleCreationChange = (dates) => {
    setCreationDateRange(dates);
  };

  const handleScheduleChange = (dates) => {
    setScheduleDateRange(dates);
  };

  const [creationStart, creationEnd] = creationDateRange;
  const [scheduleStart, scheduleEnd] = scheduleDateRange;

  const dataTable = [
    {
      ID: 1,
      jobNo: "170014",
      customer: "Movenpick Hotel – Madinah Restaurant Kitchen",
      type: "Regular Maintenance",
      paymentTerm: "Credit",
      region: "Western",
      status: "Request Approval",
      assignedTo: "Temporary",
      partOrderStatus: "",
      axReference: "",
      amount: "0.00",
      jobsType: "Onsite",
      creationDate: "04 Oct 2025",
      scheduleDate: "10 Oct 2025",
    },
    {
      ID: 2,
      jobNo: "169993",
      customer: "Movenpick Hotel – Madinah Restaurant Kitchen",
      type: "Regular Maintenance",
      paymentTerm: "Cash",
      region: "Western",
      status: "Request Approval",
      assignedTo: "Nagesh",
      partOrderStatus: "",
      axReference: "",
      amount: "0.00",
      jobsType: "Onsite",
      creationDate: "19 Sep 2025",
      scheduleDate: "22 Sep 2025",
    },
    {
      ID: 3,
      jobNo: "159079",
      customer: "ALSHAYA GROUP RC-AL REHAB ZENGABAR ST. (DT)",
      type: "Regular Maintenance",
      paymentTerm: "Credit",
      region: "Western",
      status: "Request Approval",
      assignedTo: "Nagesh",
      partOrderStatus: "-",
      axReference: "",
      amount: "287.50",
      jobsType: "Onsite",
      creationDate: "31 Dec 2024",
      scheduleDate: "08 Jan 2025",
    },
  ];

  const columns = [
    { Header: "Sr.no.", accessor: "ID", minWidth: 60 },
    { Header: `${WORK_ORDER} No.`, accessor: "jobNo", minWidth: 60 },
    { Header: "Customer", accessor: "customer", minWidth: 150 },
    { Header: "Type", accessor: "type", minWidth: 150 },
    { Header: "Payment Term", accessor: "paymentTerm", minWidth: 150 },
    { Header: "Region", accessor: "region", minWidth: 100 },
    { Header: "Assigned To", accessor: "assignedTo", minWidth: 150 },
    { Header: "Status", accessor: "status", minWidth: 200 },
    {
      Header: "Parts Order Status",
      accessor: "partOrderStatus",
      minWidth: 100,
      Cell: ({ value }) => <span>{value || "-"}</span>,
    },
    {
      Header: "Sales Reference",
      accessor: "axReference",
      minWidth: 120,
      Cell: ({ value }) => <span>{value || "-"}</span>,
    },
    { Header: "Creation Date", accessor: "creationDate", minWidth: 150 },
    { Header: "Schedule Date", accessor: "scheduleDate", minWidth: 150 },
  ];
  return (
    <Container fluid className="mt-4">
      <Row>
        <Col className="mb-5" md="12">
          <Card>
            <CardHeader className="d-flex align-items-center justify-content-between mb-2">
              <CardTitle tag="h3" className="font-weight-normal">
                Warranty Approval Requests
              </CardTitle>
              <div className="d-flex align-items-center">
                <Button
                  className="btn-simple btn-round btn-style mr-3"
                  color="default"
                  size="md"
                >
                  <i className="fas fa-arrow-up-from-bracket mr-1" /> Export {WORK_ORDER}
                </Button>
              </div>
            </CardHeader>
            <CardBody>
              <div className="d-flex flex-wrap align-items-center justify-content-start filter-group">
                <Input
                  type="text"
                  placeholder="Search by customer, technician"
                  className="mr-2 mb-2 filter-input-large"
                />
                <Row className="mx-2">
                  <div className="d-flex align-items-center mr-2 mb-2">
                    <Label className="text-muted mb-0 mr-2">
                      Creation Date
                    </Label>
                    <DatePicker
                      selected={creationStart}
                      onChange={handleCreationChange}
                      startDate={creationStart}
                      endDate={creationEnd}
                      selectsRange
                      isClearable
                      placeholderText="Select a date or range"
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                  <div className="d-flex align-items-center mx-2 mb-2">
                    <Label className="text-muted mb-0 mr-2">
                      Schedule Date
                    </Label>
                    <DatePicker
                      selected={scheduleStart}
                      onChange={handleScheduleChange}
                      startDate={scheduleStart}
                      endDate={scheduleEnd}
                      selectsRange
                      isClearable
                      placeholderText="Select a date or range"
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  </div>
                </Row>
                <Button
                  color="default"
                  className="d-flex align-items-center mb-2 filter-btn btn-simple"
                >
                  <i className="fa fa-search mr-1" />
                  Search
                </Button>
              </div>

              <div className="mt-3 mb-4 mx-1">
                <span className="font-weight-bold">
                  Total Requests: {dataTable.length}
                </span>
              </div>
              <CommonTable
                data={dataTable}
                resizable={false}
                columns={columns}
                defaultPageSize={25}
                showPaginationBottom={true}
                className="-striped -highlight table-hover"
                rowClick={(rowData) =>
                  navigate("/admin/jobs/details", { state: rowData })
                }
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default WarrantyApproval;
